<template>
  <div class="text-center ma-2">
    <v-snackbar v-model="$store.state.notify.is"
                right
                :color="$store.state.notify.type.background"
                shaped
                bottom
    >
      <div class="d-flex justify-space-between align-center">
        <span :style="{color : $store.state.notify.type.color}" ><v-icon class="ml-1" :color="$store.state.notify.type.color">{{ icon[$store.state.notify.type.icon] }}</v-icon>{{text}}</span>
        <br>
        <v-btn
            color="white"
            :style="{backgroundColor : $store.state.notify.type.color}"
            text
            @click="$store.state.notify.is = false"
        >
          متوجه شدم
        </v-btn>

      </div>
    </v-snackbar>

  </div>
</template>
<script>
import { mdiAlertCircleOutline , mdiAlertOutline ,mdiCheckCircleOutline ,mdiInformationVariant } from '@mdi/js';
export default {
  data: () => ({
    icon : {
      mdiAlertCircleOutline,
      mdiAlertOutline,
      mdiCheckCircleOutline,
      mdiInformationVariant
    }
  }),
  computed: {
    text() {
      return this.$store.state.notify.text;
    },
  },
}
</script>
